import './LandingPage.css';

const samplePosts = [
  {
    topic: 'Culture',
    question: 'Should creators show raw drafts before the polished take?',
    sideA: 'Show the process',
    sideB: 'Keep the mystique',
    pctA: 63,
    pctB: 37
  },
  {
    topic: 'Sports',
    question: 'Would you rather win ugly or lose with a beautiful system?',
    sideA: 'Win ugly',
    sideB: 'Beautiful loss',
    pctA: 51,
    pctB: 49
  }
];

const principles = [
  ['Lock first', 'Users choose a side before they see the room.'],
  ['Discuss after', 'Replies unlock once the opinion is on record.'],
  ['Track the split', 'Every Hix shows where the crowd is moving.']
];

const faqs = [
  [
    'What is Hixrs?',
    'Hixrs is a lock-in-first social app where people share takes, choose their first instinct before seeing the crowd, then unlock the live split and discussion.'
  ],
  [
    'What is a Hix?',
    'A Hix is a two-sided take. You lock in one side first, then see where the room stands and join the conversation.'
  ],
  [
    'What are Open Thoughts?',
    'Open Thoughts are free-form posts for observations, questions, images, and discussions that do not need a strict two-sided lock-in.'
  ],
  [
    'Is Hixrs a poll app?',
    'No. Polls end at a percentage. Hixrs starts with a first instinct, then turns the live split into discussion and opinion identity.'
  ]
];

function MiniHixCard({ post, active }) {
  return (
    <article className={`landing-hix-card ${active ? 'active' : ''}`}>
      <div className="landing-hix-top">
        <span>{post.topic}</span>
        <strong>{Math.abs(post.pctA - post.pctB) <= 2 ? 'Tight split' : 'Live split'}</strong>
      </div>
      <h3>{post.question}</h3>
      <div className="landing-hix-bar" aria-hidden="true">
        <span style={{ width: `${post.pctA}%` }} />
      </div>
      <div className="landing-hix-options">
        <button type="button">
          <span>{post.sideA}</span>
          <strong>{post.pctA}%</strong>
        </button>
        <button type="button">
          <span>{post.sideB}</span>
          <strong>{post.pctB}%</strong>
        </button>
      </div>
    </article>
  );
}

function LandingPage() {
  return (
    <main className="landing-page">
      <nav className="landing-nav" aria-label="Landing navigation">
        <a className="landing-brand" href="/">
          hixrs<span>.</span>
        </a>
        <div className="landing-nav-links">
          <a href="#how">How it works</a>
          <a href="#product">Product</a>
          <a className="landing-nav-cta" href="/#/app">Open app</a>
        </div>
      </nav>

      <section className="landing-hero">
        <div className="landing-hero-copy">
          <p className="landing-kicker">Opinion, with a receipt</p>
          <h1>Lock in before the room changes your mind.</h1>
          <p className="landing-lede">
            Hixrs is a lock-in-first social app for takes, Open Thoughts, live splits,
            and opinion identity. Choose your first instinct, see where the room stands,
            then understand the other side.
          </p>
          <div className="landing-actions">
            <a className="landing-primary" href="/#/app">Enter Hixrs</a>
            <a className="landing-secondary" href="#product">View the flow</a>
          </div>
        </div>

        <div className="landing-product-shot" id="product" aria-label="Hixrs product preview">
          <div className="landing-shot-shell">
            <div className="landing-shot-topbar">
              <span>hixrs.</span>
              <div>
                <i />
                <i />
                <i />
              </div>
            </div>
            <div className="landing-shot-body">
              <aside className="landing-shot-sidebar">
                <span className="is-active">Feed</span>
                <span>Hot</span>
                <span>Explore</span>
              </aside>
              <div className="landing-shot-feed">
                {samplePosts.map((post, index) => (
                  <MiniHixCard key={post.question} post={post} active={index === 0} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="landing-proof" aria-label="Product metrics">
        <div>
          <strong>2 choices</strong>
          <span>clearer than an endless comment thread</span>
        </div>
        <div>
          <strong>1 lock-in</strong>
          <span>lock in before the room influences you</span>
        </div>
        <div>
          <strong>Live split</strong>
          <span>the room keeps moving after every lock-in</span>
        </div>
      </section>

      <section className="landing-how" id="how">
        <div className="landing-section-head">
          <p className="landing-kicker">Built for clearer takes</p>
          <h2>Less noise and more signal.</h2>
        </div>
        <div className="landing-principles">
          {principles.map(([title, body]) => (
            <article key={title}>
              <h3>{title}</h3>
              <p>{body}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="landing-define" aria-label="What is Hixrs">
        <div className="landing-section-head">
          <p className="landing-kicker">What Hixrs means</p>
          <h2>First instinct, live split, better discussion.</h2>
          <p>
            Hixrs is built around a simple loop: share a take, lock in your first
            instinct, see the live split, then explain why. Majority does not mean
            right. It shows where the room stands.
          </p>
        </div>
        <div className="landing-faq-grid">
          {faqs.map(([question, answer]) => (
            <article key={question}>
              <h3>{question}</h3>
              <p>{answer}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="landing-final">
        <div>
          <p className="landing-kicker">Ready when the take is</p>
          <h2>Start with the feed. Let the split do the talking.</h2>
        </div>
        <a className="landing-primary" href="/#/app">Open Hixrs</a>
      </section>
    </main>
  );
}

export default LandingPage;
